import React, { useEffect } from 'react';
import { CheckCircle2, Mail, Download } from 'lucide-react';
import { trackPurchase } from '../lib/pixel';
export function ThankYou() {
  useEffect(() => {
    // Fire Meta Pixel Purchase event ONCE on confirmation page load.
    trackPurchase();
  }, []);
  return <div className="min-h-screen bg-zinc-50 flex items-center justify-center px-4 py-16" data-id="element-350">
      <div className="max-w-xl w-full bg-white rounded-3xl shadow-xl border border-zinc-200 p-8 md:p-12 text-center" data-id="element-351">
        <div className="w-16 h-16 mx-auto rounded-full bg-green-100 flex items-center justify-center mb-6" data-id="element-352">
          <CheckCircle2 className="w-9 h-9 text-green-600" data-id="element-353" />
        </div>
        <h1 className="text-3xl md:text-4xl font-extrabold text-zinc-900 tracking-tight mb-3" data-id="element-354">
          ¡Compra confirmada!
        </h1>
        <p className="text-lg text-zinc-600 mb-8 leading-relaxed" data-id="element-355">
          Tu acceso a{' '}
          <span className="font-semibold text-zinc-900" data-id="element-356">
            Sistema iPhone Ads
          </span>{' '}
          ya está listo. En unos minutos vas a recibir un correo con el link de
          descarga de la guía y los bonus.
        </p>

        <div className="space-y-3 text-left mb-8" data-id="element-357">
          <div className="flex items-start gap-3 p-4 bg-zinc-50 rounded-xl border border-zinc-200" data-id="element-358">
            <Mail className="w-5 h-5 text-blue-600 shrink-0 mt-0.5" data-id="element-359" />
            <div data-id="element-360">
              <p className="font-semibold text-zinc-900 text-sm" data-id="element-361">
                Revisá tu correo
              </p>
              <p className="text-zinc-600 text-sm leading-snug" data-id="element-362">
                Si no lo ves en la bandeja principal, fijate en spam o
                promociones.
              </p>
            </div>
          </div>
          <div className="flex items-start gap-3 p-4 bg-zinc-50 rounded-xl border border-zinc-200" data-id="element-363">
            <Download className="w-5 h-5 text-blue-600 shrink-0 mt-0.5" data-id="element-364" />
            <div data-id="element-365">
              <p className="font-semibold text-zinc-900 text-sm" data-id="element-366">
                Descargá los archivos
              </p>
              <p className="text-zinc-600 text-sm leading-snug" data-id="element-367">
                Guía principal + Bonus de Campañas + Bonus de Contenido, todo en
                PDF.
              </p>
            </div>
          </div>
        </div>

        <a href="/" className="inline-flex items-center justify-center px-6 py-3 text-sm font-bold text-white bg-zinc-900 rounded-full hover:bg-zinc-800 transition-colors" data-id="element-368">
          Volver al inicio
        </a>
      </div>
    </div>;
}